import type * as gql from "@/lib/graphql/generated-gql";
import type { OperationVariables } from "@apollo/client";
import type { SERVICE_NAMES } from "../apollo-client";

export async function genericQuery(
  documentName: keyof typeof gql,
  serviceName: SERVICE_NAMES,
  variables: OperationVariables,
) {
  const fetchParams: Record<string, string> = {
    documentName,
    serviceName,
    variables: JSON.stringify(variables),
  };
  const fetchUrl = `/api/query?${new URLSearchParams(fetchParams).toString()}`;

  const data = await (await fetch(fetchUrl)).json();

  return data;
}
